<template>
  <header class="max-w-[900px]">
    <h1 class="mb-1 text-2xl font-extrabold md:mb-3 md:text-3xl">
      {{ title }}
    </h1>

    <p v-if="subtitle || $slots.subtitle" class="text-subtle">
      <slot name="subtitle">
        {{ subtitle }}
      </slot>
    </p>
  </header>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

defineProps<{
  title: I18nMessage;
  subtitle?: I18nMessage;
}>();
</script>
